import { render } from "./PancreasSpecificSectionDetails.vue?vue&type=template&id=7529a28a&scoped=true"
import script from "./PancreasSpecificSectionDetails.vue?vue&type=script&lang=js"
export * from "./PancreasSpecificSectionDetails.vue?vue&type=script&lang=js"

import "./PancreasSpecificSectionDetails.vue?vue&type=style&index=0&id=7529a28a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7529a28a"],['__file',"src/components/PancreasSpecificSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7529a28a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7529a28a', __exports__)) {
    api.reload('7529a28a', __exports__)
  }
  
  module.hot.accept("./PancreasSpecificSectionDetails.vue?vue&type=template&id=7529a28a&scoped=true", () => {
    api.rerender('7529a28a', render)
  })

}


export default __exports__